export const historyItems = [
  {
    text: "Transferência realizada dia 20/06/2025 – Efetuada por Washington para Ricardo Portas",
  },
  {
    text: "Ricardo Portas editou o item: Número do Documento Fiscal em 20/06/2025",
  },
  {
    text: "Upload de Nota Fiscal do item 1.1.1 no dia 20/06/2025",
  },
]

export const fasesOrcamento = [
  {
    id: 1,
    step: "Desenvolvimento do Projeto"
  },
  {
    id: 2,
    step: "Pré-Produção"
  },
  {
    id: 3,
    step: "Produção"
  },
  {
    id: 4,
    step: "Pós-Produção"
  },
  {
    id: 5,
    step: "Comercialização"
  },
  {
    id: 6,
    step: "Despesas Administrativas"
  },
  {
    id: 7,
    step: "Tributos e Taxas"
  },
  {
    id: 8,
    step: "Gerenciamento"
  }
]